





















































































































































































































































import Api from "@/api/Api";
import { Advertisement } from "@/interfaces/advertisement";
import Vue from "vue";
import { mapGetters } from "vuex";

const api = Api.singleton();
export default Vue.extend({
  computed: {
    ...mapGetters(["my"]),
    isPage() {
      return true;
    },
    isImpersonated(): boolean {
      return api.jwtToken.isGranted(["ROLE_IMPERSONATOR"]);
    }
  },
  methods: {
    async fetchAdvertisements() {
      this.loading = true;
      const params: { [key: string]: string | number } = {
        owner: this.my().advertiserId || "",
        page: this.page,
        itemsPerPage: this.perPage
      };
      if (this.sortField == "area") {
        params["order[publishmentOrder.region.id]"] = this.sortOrder;
        params["order[publishmentOrder.locality.id]"] = this.sortOrder;
      } else {
        params["order[" + this.sortField + "]"] = this.sortOrder;
      }
      const res = await api.call({
        method: "GET",
        resource: "/api/adv/posts",
        query: params
      });
      this.advertisements = res["hydra:member"];
      this.total = res["hydra:totalItems"];
      this.loading = false;
    },
    onPageChange(page: number) {
      this.page = page;
      this.fetchAdvertisements();
    },
    onSort(field: string, order: string) {
      this.sortField = field;
      this.sortOrder = order;
      this.fetchAdvertisements();
    },
    getDistributionStatus(advertisement: Advertisement): string {
      if (
        !advertisement.publicAdvertisement ||
        !advertisement.publishmentOrder
      ) {
        return "";
      }
      if (advertisement.publicAdvertisement.postStatus == "public") {
        const now = new Date();
        if (now < new Date(advertisement.publishmentOrder.publishesAt)) {
          return "予約投稿済";
        }
        const unpublishesAt = new Date(
          advertisement.publishmentOrder.unpublishesAt
        );
        unpublishesAt.setHours(0);
        unpublishesAt.setDate(unpublishesAt.getDate() + 1);
        if (unpublishesAt < now) {
          return "掲載終了";
        }
        return "掲載中";
      }
      if (advertisement.publicAdvertisement.postStatus == "not_synced") {
        return "(未連携)";
      }
      if (advertisement.publicAdvertisement.postStatus == "suspended") {
        return "掲載停止中";
      }

      return "";
    }
  },
  mounted() {
    (async () => {
      const userLogin = await Api.singleton().call({
        method: "get",
        resource:
          "/api/adv/user_logins/" +
          Api.singleton().jwtToken.currentTokenObject?.user_login_id
      });
      if (userLogin.isTemporaryPassword) {
        alert("パスワードの変更が必要です。");
        this.$router.push({ name: "AdvertiserPassword" });
      }
    })();
    this.fetchAdvertisements();
  },
  data() {
    return {
      advertisements: [],
      page: 1,
      perPage: 10,
      defaultSortOrder: "id",
      sortField: "id",
      sortOrder: "desc",
      total: NaN,
      loading: true
    };
  }
});
